// extracted by mini-css-extract-plugin
module.exports = {"root":"ProfileSidebarView_root__wcHxc","header":"ProfileSidebarView_header__W2b58","container":"ProfileSidebarView_container__5PhtW"};